import {
  Box,
  Button,
  Modal,
  Stack,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import RoleTab from './RoleTab';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #707070',
  boxShadow: 24,
  p: 4,
};

export default function SelectRoleModal({
  visible = false,
  onClose = () => {},
  onFinish = () => {},
  promptDetails = {},
  allInfluencerRoles = [],
}) {
  const [allowSelectRoles, setAllowSelectRoles] = useState(null);
  const [selectedRoleForManufacturer, setSelectedRoleForManufacturer] =
    useState({});

  const handleToggleChange = (newAlignment) => {
    if (newAlignment === null) return;
    if (!newAlignment) onClose();
    setAllowSelectRoles(newAlignment);
  };

  useEffect(() => {
    setAllowSelectRoles(null);
    setSelectedRoleForManufacturer({});
  }, [visible]);

  return (
    <Modal
      open={visible}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={style}
        style={{ overflowY: 'auto' }}
      >
        {!allowSelectRoles ? (
          <>
            <Stack>
              <Typography
                variant='button'
                sx={{
                  fontWeight: 'bold',
                  textAlign: 'center',
                  fontSize: '1.3rem',
                }}
              >
                User Not Found
              </Typography>
              <Typography
                variant='subtitle1'
                sx={{
                  marginTop: 1.5,
                }}
              >
                {promptDetails?.prompted_message}
              </Typography>
            </Stack>
            <Stack
              direction={'row'}
              gap={2}
              sx={{
                justifyContent: 'flex-end',
                marginTop: 5,
              }}
            >
              <Button
                onClick={onClose}
                variant='contained'
                color='error'
              >
                Cancel
              </Button>
              <Button
                variant='contained'
                onClick={() => handleToggleChange(true)}
              >
                Add as Influencer
              </Button>
            </Stack>
          </>
        ) : (
          <Stack
            sx={{
              marginTop: 5,
            }}
          >
            {allowSelectRoles && (
              <>
                <Typography
                  variant='button'
                  sx={{ fontWeight: 'bold' }}
                >
                  Select a Influencer Role
                </Typography>

                <Stack
                  sx={{
                    marginTop: 1,
                  }}
                  direction={'row'}
                  gap={2}
                >
                  {allInfluencerRoles.map((role) => (
                    <RoleTab
                      display_name={role.display_name}
                      selected={
                        selectedRoleForManufacturer?.display_name ===
                        role.display_name
                      }
                      onClick={() => setSelectedRoleForManufacturer(role)}
                    />
                  ))}
                </Stack>

                <Stack
                  direction={'row'}
                  gap={2}
                  sx={{
                    justifyContent: 'flex-end',
                    marginTop: 5,
                  }}
                >
                  <Button
                    onClick={onClose}
                    variant='contained'
                    color='error'
                  >
                    Cancel
                  </Button>
                  <Button
                    variant='contained'
                    onClick={() =>
                      onFinish(promptDetails?.id, selectedRoleForManufacturer)
                    }
                  >
                    add {selectedRoleForManufacturer?.display_name || ''}
                  </Button>
                </Stack>
              </>
            )}
          </Stack>
        )}
      </Box>
    </Modal>
  );
}
